import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import Select, { StylesConfig } from "react-select";
import { mapMstToOptions } from "utils/HelperFunction";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { VER } from "constants/server/api";
import { LOGO_URL, SERVER_NAME } from "constants/server/config";
import { env } from "env";
import CheckIcon from "@mui/icons-material/Check";
export function ForgetpassSuccess() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    useEffect(function() {
        localStorage.clear();
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: "loginpage bg-white",
        children: /*#__PURE__*/ _jsx(Row, {
            className: "g-0",
            children: /*#__PURE__*/ _jsx(Col, {
                className: "d-flex justify-content-center align-items-center h-100vh",
                children: /*#__PURE__*/ _jsx(Card, {
                    className: "box-login",
                    style: {
                        maxWidth: "550px"
                    },
                    children: /*#__PURE__*/ _jsxs(Card.Body, {
                        className: "",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "d-flex justify-content-center align-items-center mb-3",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "p-3",
                                    style: {
                                        borderRadius: "100px",
                                        backgroundColor: "#2DC76D"
                                    },
                                    children: /*#__PURE__*/ _jsx(CheckIcon, {
                                        sx: {
                                            fontSize: 100,
                                            color: "#FFFFFF"
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-center fs-20 fw-500 tc-1 mb-4",
                                children: "กำหนดรหัสผ่านสำเร็จ"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-login w-100",
                                onClick: function() {
                                    return navigate("/login");
                                },
                                children: "คลิกที่นี่เพื่อเข้าสู่ระบบ"
                            })
                        ]
                    })
                })
            })
        })
    });
}
